import { computed, observable } from 'mobx';

export class EnvModel {
  constructor() {
    this.baseUrl = process.env.APP_PROTOCOL + '//' + process.env.APP_URL;
    this.apiUri = process.env.APP_PROTOCOL + '//' + process.env.API_URL;
    this.graphqlUri = process.env.GRAPHQL_PROTOCOL + '//' + process.env.GRAPHQL_URL;
    this.authUri = process.env.APP_PROTOCOL + '//' + process.env.AUTH_URL;
    this.audioUri = process.env.APP_PROTOCOL + '//' + process.env.AUDIO_URL;
    this.imagesUri = process.env.APP_PROTOCOL + '//' + process.env.IMAGES_URL;
    this.waveformsUri = process.env.APP_PROTOCOL + '//' + process.env.WAVEFORMS_URL;
    this.staticUri = process.env.APP_PROTOCOL + '//' + process.env.STATIC_URL;
    this.trackReferralUri = process.env.APP_PROTOCOL + '//' + process.env.TRACK_REFERRAL_URL;
  }

  @observable
  es6: boolean = false;

  @observable
  startupPromises: Array<Promise<any>> = [];

  @computed
  get ready(): Promise<any> {
    return Promise.all(this.startupPromises);
  }

  @observable
  appEnv: string = process.env.APP_ENV;

  @observable
  isServer: boolean = !!process.env.SERVER;

  @observable
  baseUrl: string;

  @observable
  apiUri: string;

  @observable
  authUri: string;

  @observable
  audioUri: string;

  @observable
  imagesUri: string;

  @observable
  waveformsUri: string;

  @observable
  staticUri: string;

  @observable
  graphqlUri: string;

  @observable
  trackReferralUri: string;

  @observable
  version: string = process.env.VERSION;

  @observable
  stripeKey: string = process.env.STRIPE_KEY;

  @observable
  googleApiKey: string = process.env.GOOGLE_JS_API_KEY;

  @observable
  ga = {
    id: process.env.GOOGLE_ANALYTICS,
    trackingVersion: '1'
  };

  @observable
  bugsnagKey: string = process.env.BUGSNAG_KEY;

  @observable
  pusherKey: string = process.env.PUSHER_KEY;

  @observable
  prismicEndpoint: string = process.env.PRISMIC_ENDPOINT;

  @observable
  prismicLandingEndpoint: string = process.env.PRISMIC_LANDING_ENDPOINT;

  @observable
  queryStringCookies: Array<string> = process.env.QUERY_STRING_COOKIES
    ? process.env.QUERY_STRING_COOKIES.split(',')
    : [];

  @observable
  addThisKey: string = 'ra-5a38e640c10ce83f';

  @observable
  playlistFavourites: string = process.env.PLAYLIST_FAVOURITES;

  @observable
  artistlistFavourites: string = process.env.ARTISTLIST_FAVOURITES;

  @observable
  exampleLicenseUri: string = `${process.env.LICENSE_URL}/${process.env.LICENSE_EXAMPLE_PATH}`;

  @observable
  goldenTicketBackgroundIdentity: string = process.env.GOLDEN_TICKET_BACKGROUND_IDENTITY;

  @observable
  channelReferralBackgroundIdentity: string = process.env.CHANNEL_REFERRAL_BACKGROUND_IDENTITY;

  @observable
  keenProjectId: string = process.env.KEENIO_PROJECT_ID;

  @observable
  keenWriteKey: string = process.env.KEENIO_WRITE_KEY;

  @observable
  keenChannelReferralVisit: string = 'channel_referral_visit';

  @observable
  keenChannelReferralClick: string = 'channel_referral_click';
}